var _NumberFormatterDelegates_config;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { format } from '../Strings';
import padLeft from '../Strings/padLeft';
export default class NumberFormatterDelegates {
    constructor(numberFormatterConfiguration) {
        _NumberFormatterDelegates_config.set(this, void 0);
        __classPrivateFieldSet(this, _NumberFormatterDelegates_config, numberFormatterConfiguration, "f");
    }
    formatCurrency(subject, precision = __classPrivateFieldGet(this, _NumberFormatterDelegates_config, "f").currencyDecimalDigits) {
        return format(__classPrivateFieldGet(this, _NumberFormatterDelegates_config, "f").currencyFormat, this.formatFixed(Math.abs(subject), precision), subject < 0 ? "-" : "");
    }
    formatInteger(subject, minDigits = 0) {
        if (subject < 0) {
            return `-${padLeft(Math.abs(subject).toFixed(0), minDigits, "0")}`;
        }
        else {
            return padLeft(subject.toFixed(0), minDigits, "0");
        }
    }
    formatExponential(subject, precision = 6) {
        return subject.toExponential(precision);
    }
    formatFixed(subject, precision = __classPrivateFieldGet(this, _NumberFormatterDelegates_config, "f").numberDecimalDigits) {
        return subject.toFixed(precision);
    }
    formatGeneral(subject, precision) {
        const fixed = this.formatFixed(subject, precision);
        const expon = this.formatExponential(subject, precision);
        return fixed.length <= expon.length
            ? fixed
            : expon;
    }
    formatNumber(subject, precision = __classPrivateFieldGet(this, _NumberFormatterDelegates_config, "f").numberDecimalDigits) {
        return this.formatFixed(subject, precision);
    }
    formatPercent(subject, precision = __classPrivateFieldGet(this, _NumberFormatterDelegates_config, "f").percentDecimalDigits) {
        return `${this.formatFixed(subject, precision)} %`;
    }
    formatHexadecimal(subject, precision = 0) {
        return padLeft(subject.toString(16), precision, "0");
    }
}
_NumberFormatterDelegates_config = new WeakMap();
